/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { UpdateOnboardingPreferencesMutationRequest, UpdateOnboardingPreferencesMutationResponse, UpdateOnboardingPreferencesPathParams, UpdateOnboardingPreferences400, UpdateOnboardingPreferences401, UpdateOnboardingPreferences403, UpdateOnboardingPreferences404, UpdateOnboardingPreferences409, UpdateOnboardingPreferences500 } from "../../types/onboardingController/UpdateOnboardingPreferences.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getUpdateOnboardingPreferencesUrl(organizationId: UpdateOnboardingPreferencesPathParams["organizationId"]) {
  const res = { method: 'PATCH', url: `/api/organizations/${organizationId}/onboarding/preferences` as const }
  return res
}

/**
 * @summary Update onboarding preferences or acknowledge completion
 * {@link /api/organizations/:organizationId/onboarding/preferences}
 */
export async function updateOnboardingPreferences(organizationId: UpdateOnboardingPreferencesPathParams["organizationId"], data: UpdateOnboardingPreferencesMutationRequest, config: Partial<RequestConfig<UpdateOnboardingPreferencesMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<UpdateOnboardingPreferencesMutationResponse, ResponseErrorConfig<UpdateOnboardingPreferences400 | UpdateOnboardingPreferences401 | UpdateOnboardingPreferences403 | UpdateOnboardingPreferences404 | UpdateOnboardingPreferences409 | UpdateOnboardingPreferences500>, UpdateOnboardingPreferencesMutationRequest>({ method : "PATCH", url : getUpdateOnboardingPreferencesUrl(organizationId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}